import {
    createIconText,
    IconText,
} from '@vfde-brix/ws10/icon-text';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { selectAtomicDevice } from 'Container/App/selectors';
import { startAppListening } from 'Container/App/listener';

/**
 * Mount icon text
 */
const mountIconText = (containerId: string): IconText | null => {
    const containerElement = document.getElementById(containerId);

    const deliveryDate = containerElement && createIconText(containerElement, NO_PATTERN_BUSINESS_LOGIC);

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectAtomicDevice(currentState) !== selectAtomicDevice(previousState),
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const atomicDevice = selectAtomicDevice(listenerApi.getState());

            atomicDevice && deliveryDate?.update({
                txtContent: atomicDevice.deliveryDate,
            });
        },
    });

    return deliveryDate;
};

export default mountIconText;
